module.exports = __webpack_public_path__ + "static/publications-a251bcb3c7774f058c362116985362d1.jpeg";